import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_CV,
  GET_CV_BY_ID,
  GET_CV_MINE,
  GET_CATEGORY_CANDIDATE_CV,
  GET_CV_DETAILS_BY_ID,
  GET_FILTERD_CV,
  GET_ALREADY_DOWNLOADED_CV_LIST
} from "../constants";

export const getCVList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal`);
    if (response?.data?.status) {
      dispatch({ type: GET_CV, getcvlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getCandidatefromcategory = (search) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=1&expert=1&search=${search ?? ""}`);
    if (response?.data?.status) {
      dispatch({ type: GET_CATEGORY_CANDIDATE_CV, getcvcandidatelistcategory: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getAlreadyDownloadedCVList = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal/downloads?type=7&index=${data?.index}&size=${data?.size}`);
    if (response?.data?.status) {
      dispatch({ type: GET_ALREADY_DOWNLOADED_CV_LIST, getalreadydownloadedcvlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getSimilarCVList = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal/search?type=8&user_id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_ALREADY_DOWNLOADED_CV_LIST, getalreadydownloadedcvlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};






export const FilterCVListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("proposal/search", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_CV, getfilterdcv: response?.data?.response });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};



export const downloadCV = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`proposal/downloadcv`, data);
    if (response?.data?.status) {
      return;
    }
    // urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const getCVDetailsById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auth/get-profile?user_id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_CV_DETAILS_BY_ID, getcvbyuserid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineCVList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_CV_MINE,
        getminecvlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addCV = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("proposal/create", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateCV = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineCVList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getCVById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_CV_BY_ID, getcvbyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const deleteCV = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`proposal/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineCVList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};
